export default {
  title: 'Tuonti on käynnissä... 🙂',
  description: 'Slack-ilmoitukset lähetetään, kun tuonti on valmis.',
  buttons: {
    open_followers_list: 'Avaa seuraajalista',
  },
};
